import { render, staticRenderFns } from "./ConfirmCancellationPage.vue?vue&type=template&id=52ebb586"
import script from "./ConfirmCancellationPage.vue?vue&type=script&lang=js"
export * from "./ConfirmCancellationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports